import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const gridRowFn = /* @__PURE__ */ createRecipe('grid-row', {}, [])

const gridRowVariantMap = {
  "gap": [
    "gap100",
    "gap200",
    "gap300",
    "gap400",
    "gap500",
    "gap600",
    "gap700",
    "gap800",
    "gap900"
  ],
  "rowGap": [
    "gap100",
    "gap200",
    "gap300",
    "gap400",
    "gap500",
    "gap600",
    "gap700",
    "gap800",
    "gap900"
  ],
  "colGap": [
    "gap100",
    "gap200",
    "gap300",
    "gap400",
    "gap500",
    "gap600",
    "gap700",
    "gap800",
    "gap900"
  ],
  "gapS": [
    "gap100",
    "gap200",
    "gap300",
    "gap400",
    "gap500",
    "gap600",
    "gap700",
    "gap800",
    "gap900"
  ],
  "rowGapS": [
    "gap100",
    "gap200",
    "gap300",
    "gap400",
    "gap500",
    "gap600",
    "gap700",
    "gap800",
    "gap900"
  ],
  "colGapS": [
    "gap100",
    "gap200",
    "gap300",
    "gap400",
    "gap500",
    "gap600",
    "gap700",
    "gap800",
    "gap900"
  ],
  "gapM": [
    "gap100",
    "gap200",
    "gap300",
    "gap400",
    "gap500",
    "gap600",
    "gap700",
    "gap800",
    "gap900"
  ],
  "rowGapM": [
    "gap100",
    "gap200",
    "gap300",
    "gap400",
    "gap500",
    "gap600",
    "gap700",
    "gap800",
    "gap900"
  ],
  "colGapM": [
    "gap100",
    "gap200",
    "gap300",
    "gap400",
    "gap500",
    "gap600",
    "gap700",
    "gap800",
    "gap900"
  ],
  "gapL": [
    "gap100",
    "gap200",
    "gap300",
    "gap400",
    "gap500",
    "gap600",
    "gap700",
    "gap800",
    "gap900"
  ],
  "rowGapL": [
    "gap100",
    "gap200",
    "gap300",
    "gap400",
    "gap500",
    "gap600",
    "gap700",
    "gap800",
    "gap900"
  ],
  "colGapL": [
    "gap100",
    "gap200",
    "gap300",
    "gap400",
    "gap500",
    "gap600",
    "gap700",
    "gap800",
    "gap900"
  ]
}

const gridRowVariantKeys = Object.keys(gridRowVariantMap)

export const gridRow = /* @__PURE__ */ Object.assign(memo(gridRowFn.recipeFn), {
  __recipe__: true,
  __name__: 'gridRow',
  __getCompoundVariantCss__: gridRowFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: gridRowVariantKeys,
  variantMap: gridRowVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, gridRowVariantKeys)
  },
  getVariantProps: gridRowFn.getVariantProps,
})